<template>
  <v-app v-if="isLoggedIn">
    <v-layout row>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <need-assistant @click="onClickAssistant($event)" />
      </v-dialog>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="project mt-2">
          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn class="white--text" flat @click="createProjectPage()">
              create project
            </v-btn>
            <v-btn
              class="white--text"
              flat
              v-if="getProjectType() == 2"
              @click="locationPage()"
            >
              Location
            </v-btn>
            <v-btn class="white--text" flat @click="back()">Question</v-btn>
            <v-btn class="white--text" flat @click="assignTeamToProject()">
              Assign Team To Project
            </v-btn>
            <v-btn
              class="white--text"
              flat
              v-if="getProjectType() == 2"
              @click="locationBasedBudgetPage()"
            >
              Location Budget
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-container grid-list-md>
            <v-card class="grey lighten-3">
              <v-card-title class="project">
                <div>
                  <span class="headline">Budget</span>
                </div>

                <div class="red--text headline ml-2">
                  <v-btn
                    color="white darken-1"
                    small
                    dark
                    class="no-upercase red--text"
                    @click="needAssistant"
                  >
                    Need assistance
                  </v-btn>
                </div>
              </v-card-title>
              <v-card-text>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout row v-if="indexData.project_data.agent_option != 3">
                    <v-flex xs4>
                      <v-subheader>Minimum Per Survey Cost</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <v-subheader class="black--text">
                        {{ getMin_per_survey_cost() }} Tk
                      </v-subheader>
                    </v-flex>
                  </v-layout>
                  <v-layout row v-if="indexData.project_data.agent_option != 3">
                    <v-flex xs4>
                      <v-subheader>Total Budget</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        @focus="totalBudget"
                        v-model="budget.total_budget_amount"
                        :value="total"
                        type="number"
                        label="Amount"
                        prefix="Tk"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout v-if="indexData.project_data.agent_option != 3" row>
                    <v-flex xs4>
                      <v-subheader>Per Survey Cost</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        v-model="budget.per_survey_cost"
                        label="Amount"
                        type="number"
                        prefix="Tk"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row>
                    <v-flex xs4>
                      <v-subheader>Total Response</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        @focus="totalResponse"
                        v-model="budget.number_of_response"
                        :value="total"
                        :rules="totalResponseRules"
                        type="number"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <!-- <v-layout row>
                    <v-flex xs4>
                      <v-subheader>Vat (+5%)</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <v-subheader class="black--text">
                        {{ vat() }} Tk
                      </v-subheader>
                    </v-flex>
                  </v-layout> -->
                  <!-- <v-layout row>
                    <v-flex xs4>
                      <v-subheader>Grand Total</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <v-subheader class="black--text">
                        {{ grandTotal() }} Tk
                      </v-subheader>
                    </v-flex>
                  </v-layout> -->
                </v-form>
              </v-card-text>

              <v-card-actions>
                <button class="button" flat @click="back">Back</button>
                <v-spacer></v-spacer>
                <v-btn class="button" flat @click="submit">Preview</v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
// import router from "../../router";
import { NeedAssistant } from "@/components/index";

export default {
  components: {
    NeedAssistant,
  },
  data: () => ({
    apiUrl: "project-info",
    dialog: false,
    defaultItem: {
      total_budget_amount: 0,
      per_survey_cost: 0,
      number_of_response: 0,
      project_id: null,
      vat: 0,
      grand_total: 0,
    },
    budget: {
      total_budget_amount: 0,
      per_survey_cost: 0,
      number_of_response: 0,
      project_id: null,
      vat: 0,
      grand_total: 0,
    },
    val: "",
    minimum_survey_cost: "",
    minimum_filtering_cost: "",
    result: 0,

    valid: true,
    totalBudgetRules: [(v) => v > 0 || "This value must be greater than zero."],
    totalResponseRules: [
      (v) =>
        Number.isInteger(Number(v)) || "The value must be an integer number",
    ],
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),

    total: function () {
      return this.calculationMethod(this.val);
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.budget.project_id = project_id;
      this.$store.dispatch("indexData", [this.apiUrl, project_id]);
      if (typeof this.indexData.project_data != "undefined") {
        var minPrice = this.indexData.projectType[0].min_price;
        var project_question_Data = JSON.parse(
          this.indexData.project_data.project_question_json
        );
        var questionPrice = project_question_Data.total_category_price;
        if ((minPrice != null) & (questionPrice != null)) {
          this.minimum_survey_cost = minPrice;
          this.minimum_question_price = questionPrice;
        } else {
          alert("Minimum and total question price should not be null");
        }
      }

      // calculate highest minimum price
      this.result = Math.max(
        Number(this.minimum_survey_cost),
        Number(this.minimum_question_price)
      );
    },
    calculationMethod(valueFrom) {
      if (valueFrom == 1) {
        let calculatedTotal =
          this.budget.total_budget_amount / this.budget.per_survey_cost;
        this.budget.number_of_response = parseInt(calculatedTotal) || 0;

        return calculatedTotal || 0;
      }
      if (valueFrom == 2) {
        let budgetTotal =
          this.budget.number_of_response * this.budget.per_survey_cost;
        this.budget.total_budget_amount = budgetTotal || 0;

        return budgetTotal || 0;
      }
    },
    totalBudget() {
      this.val = 1;
    },
    totalResponse() {
      this.val = 2;
    },
    getMin_per_survey_cost() {
      if (this.indexData.project_data) {
        var project_question_Data = JSON.parse(
          this.indexData.project_data.project_question_json
        );
        var questionPrice = project_question_Data.total_category_price;
        // console.log(project_question_Data);
        this.minimum_question_price = questionPrice;
        this.minimum_survey_cost = this.indexData.projectType[0].min_price;
        this.result = Math.max(
          Number(this.minimum_survey_cost),
          Number(this.minimum_question_price)
        );
      }
      return this.result;
    },
    vat() {
      let vat = (5 * this.budget.total_budget_amount) / 100;
      this.budget.vat = vat;
      return vat;
    },
    grandTotal() {
      let total = this.budget.total_budget_amount + this.budget.vat;
      this.budget.grand_total = total;
      return total;
    },
    back() {
      // localStorage.setItem("BudgetObject", JSON.stringify(this.budget));
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.$store.dispatch("indexDataAndRout", [
        "question-json",
        project_id,
        "/dynamic-question",
      ]);
      // router.push("/dynamic-question");
    },
    getProjectType() {
      if (this.indexData.project_data) {
        if (this.indexData.project_data.project_type_id) {
          return this.indexData.project_data.project_type_id;
        }
      }
      return false;
    },
    assignTeamToProject() {
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.$store.dispatch("indexDataAndRout", [
        "project-dasher-category",
        project_id,
        "/assign-teams-to-Project",
      ]);
    },
    createProjectPage() {
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.$store.dispatch("indexDataAndRout", [
        "project-info",
        project_id,
        "/create-project-edit",
      ]);
    },

    needAssistant() {
      this.dialog = true;
      // this.snackbar = true;
      // this.close();
    },
    onClickAssistant(event) {
      if (event == 1) {
        this.dialog = false;
        this.snackbar = true;
        this.close;
      } else {
        this.dialog = false;
      }
    },

    submit() {
      if (
        this.getProjectType() == 3 ||
        this.budget.per_survey_cost >= this.minimum_survey_cost
      ) {
        if (Number.isInteger(Number(this.budget.per_survey_cost))) {
          if (this.$refs.form.validate()) {
            this.$store.dispatch("storeOrUpdateBudget", [
              "project-budget",
              this.budget,
            ]);
          }
        } else {
          alert("Per survey cost must be an integer value!");
        }
      } else {
        alert(
          "Per survey cost must be " +
            this.minimum_survey_cost +
            " or greater than!"
        );
      }
    },
  },
};
</script>

<style scoped>
.icon {
  background: #ff2e2e;
  color: aliceblue;
  cursor: pointer;
  border-radius: none;
  margin: 10px;
}
.delete {
  color: #3f51b5;
  cursor: pointer;
}
span {
  width: 20px;
  cursor: pointer;
}
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
.no-upercase {
  text-transform: unset !important;
}
</style>
